import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';

interface DialogData {

}

enum DataTypes {
  BID = "BID",
  ORDER = "ORDER"
}

@Component({
  selector: 'app-part-level-details',
  templateUrl: './part-level-details.component.html',
  styleUrls: ['./part-level-details.component.scss']
})
export class PartLevelDetailsComponent implements OnInit {

  rowData;
  enquiryId;
  vendorOrderItems: any = [];
  partDetails;
  currentIndex;
  pendingPo: boolean;
  awardedRfq: boolean;
  currency:string;
  type: DataTypes = DataTypes.BID;



  constructor(
    public dialogref: MatDialogRef<PartLevelDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private loaderService: LoaderService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.rowData = this.data["data"];
    this.type = this.data["type"];
    this.currency = this.data['currency'] ?? 'INR';
    console.log(this.rowData)
    if (this.rowData.status === "Order Placed") {
      this.pendingPo = true;
    }
    else if (this.rowData.status === "Awarded") {
      this.awardedRfq = true;
    }
    // if (this.rowData = null) {
    //   this.toastr.error('We were not able to fetch the part details');
    //   this.close()
    // }
    this.currentIndex = this.data["index"];
    if(this.type === DataTypes.BID){
      this.rowData.vendor_bid_items.filter(x => this.vendorOrderItems.push(x.id));
    }
    else if(this.type === DataTypes.ORDER){
      this.rowData.vendor_order_items.filter(x => this.vendorOrderItems.push(x.id));
    }
    this.enquiryId = this.rowData.id;
    this.setPartId(this.vendorOrderItems[this.currentIndex]);

  }

  setPartId(id) {
    let data = this.vendorOrderItems.findIndex(ele => ele === id);
    this.currentIndex = data;
    if(this.type === DataTypes.BID){
      this.getPartDetails(this.enquiryId, this.vendorOrderItems[this.currentIndex]);
    }
    else if(this.type === DataTypes.ORDER){
      this.getPartDetailsOrder(this.enquiryId, this.vendorOrderItems[this.currentIndex]);
    }
  }

  getPartDetails(rfqId, itemId) {
    this.adminService.getVendorItemDetails(rfqId, itemId).subscribe(
      (res: any) => {
        this.partDetails = res.body;
        this.loaderService.display(false);
      },
      err => {
        this.toastr.error('Something went wrong', 'Error');
        this.loaderService.display(false);
        this.partDetails = []
      }
    );
  }

  getPartDetailsOrder(rfqId, itemId){
    this.adminService.getVendorOrderItemDetails(rfqId, itemId).subscribe(
      (res: any) => {
        this.partDetails = res.body;
        this.loaderService.display(false);
      },
      err => {
        this.toastr.error('Something went wrong', 'Error');
        this.loaderService.display(false);
        this.partDetails = []
      }
    );
  }

  previousPart() {
    if (this.currentIndex == 0) {
      this.setPartId(this.vendorOrderItems[this.vendorOrderItems.length - 1])
    }
    else {
      this.setPartId(this.vendorOrderItems[this.currentIndex - 1])
    }
  }

  nextPart() {
    if (this.currentIndex == this.vendorOrderItems.length - 1) {
      this.setPartId(this.vendorOrderItems[0])
    }
    else {
      this.setPartId(this.vendorOrderItems[this.currentIndex + 1])
    }
  }

  close() {
    this.dialogref.close();
  }

  downloadModelFile() {
    window.open(this.partDetails.model_attributes.model_file_url, "_blank");
  }

  downloadDrawing() {
    if (this.partDetails.drawings.length == 0 && this.partDetails.techfiles.length == 0) {
      this.toastr.info('There are no 2D file to download', 'Info');
    }
    else {
      for (var i = 0; i < this.partDetails.drawings.length; i++) {
        window.open(this.partDetails.drawings[i].drawing_file.url, "_blank")
      }
      for (var i = 0; i < this.partDetails?.techfiles?.length; i++) {
        window.open(this.partDetails?.techfiles[i]?.tech_file?.url, "_blank")
      }
      this.toastr.success('Files have been downloaded', 'Success')
    }
  }

  downloadCustomInspectionFile(){
    if (this.partDetails?.custom_inspection_files?.length == 0) {
      this.toastr.info('There are no custom-inspection files to download', 'Info');
    }
    else {
      for (let i = 0; i < this.partDetails.custom_inspection_files.length; i++) {
        window.open(this.partDetails.custom_inspection_files[i].custom_inspection_file.url, "_blank")
      }
      this.toastr.success('Files have been downloaded', 'Success')
    }
  }



}
